import { render, staticRenderFns } from "./_template-role-selector.vue?vue&type=template&id=27d6e69d&scoped=true&"
import script from "./_template-role-selector.vue?vue&type=script&lang=js&"
export * from "./_template-role-selector.vue?vue&type=script&lang=js&"
import style0 from "./_template-role-selector.vue?vue&type=style&index=0&id=27d6e69d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6e69d",
  null
  
)

export default component.exports